import $ from 'jquery';
import { showSidebarTab, toggleEditorSidebar } from '~src/sidebarLegacy';
import { updateObjectShadow } from '~src/sidebar/index';
import { getState } from '~src/state';

export const toggleObjectShadow = (event) => {
  // Event is optional when called from floating controls
  if (event && typeof event.preventDefault === 'function') {
    event.preventDefault();
  }
  const isSidebarOpen = getState('isSidebarOpen');
  const isShadowTabActive = $('#tab-object-shadow').hasClass('active');

  if (isSidebarOpen && isShadowTabActive) {
    // If sidebar is open and shadow tab is already active, close sidebar
    toggleEditorSidebar();
  } else {
    // If sidebar is closed or showing different tab, show shadow tab
    $('#sidebar-content .tab').removeClass('active');
    showSidebarTab('object-shadow');
    updateObjectShadow();
  }
};
